// extracted by mini-css-extract-plugin
export default {"imgContain":"mO","content":"nO","titleAndImage":"oO","title":"pO","text":"qO","rhodeTitle":"rO","shortHR":"sO","modal_root":"tO","x_mark":"uO","flavorStickModal":"vO","greenBox":"wO"};
    if(module.hot) {
      // 1738836197276
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  